export const ROUTES = {
  MODULES: "/modules",
  FORGE: "/forge",
  ORGANIZATION: "/organization",
  CONTACT: "/contact",
  SELECT_FORGE_TYPE: "/forge/select-forge-type",
  CUSTOM_FORGE: "/forge/select-forge-type/custom-forge",
  // FORGE_WITH_LAILA: "/forge/select-forge-type/forge-with-laila",
  FORGING_PROGRESS: "/forge/forging-progress",
  SELECT_MODULE: "/forge/select-forge-type/select-module",
  USER_MANAGEMENT: "/organization/user-management",
  MONITORING: "/organization/monitoring",
}

export const ROUTE_HIERARCHY = {
  "/forge": {
    "/forge/select-forge-type": {
      "/forge/select-forge-type/custom-forge": "Custom Forge",
      // "/forge/select-forge-type/forge-with-laila": "Forge with Laila",
      "/forge/select-forge-type/select-module": "Select Module",
    },
  },
}

export const ROUTE_LABELS: Record<string, string> = {
  "forging-progress": "Forging In Progress",
  "monitoring": "Monitoring & Activity timeline",
}
